import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import AdbIcon from "@mui/icons-material/Adb";
import "../../styles/header/style.scss";
import "../../styles/commonStyle.scss";
import { useNavigate } from "react-router-dom";
import ourServicesContent from "../ourServices/ourServicesContent";

const pages = ["Home", "Services", "Case Studies", "Blog", "About"];
const settings = ["Home", "Services", "Case Studies", "Blog", "About"];

const HeaderComponent = ({ handleScrollToPortion, headerName, ref }) => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const navigate = useNavigate();
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar position="static" className="header-parent-container" ref={ref}>
      <Container
        maxWidth="xl"
        className={headerName ? "service-header-wrapper" : ""}
      >
        <Toolbar disableGutters>
          {!headerName && (
            <Typography
              variant="h6"
              noWrap
              component="a"
              onClick={() => {
                handleScrollToPortion("Home");
              }}
              // href="https://wizzgeeks.com/"
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
              }}
            >
              <div className="company-logo-container cursor-pointer">
                <img
                  src="/images/common/company-logo-colored.svg"
                  alt="wizzgeeks"
                />
              </div>
            </Typography>
          )}
          {!headerName && (
            <Box
              sx={{
                flexGrow: 1,
                display: { xs: "flex", md: "none" },
                justifyContent: "flex-start",
              }}
            >
              <Typography
                variant="h6"
                noWrap
                component="a"
                onClick={() => {
                  handleScrollToPortion("Home");
                }}
                sx={{
                  mr: 2,
                  display: { xs: "flex", md: "none" },
                  fontFamily: "monospace",
                  fontWeight: 700,
                  letterSpacing: ".3rem",
                  color: "inherit",
                  textDecoration: "none",
                }}
              >
                <div className="company-logo-container cursor-pointer">
                  <img
                    src="/images/common/company-logo-black.svg"
                    alt="Company Logo"
                  />
                </div>
              </Typography>
            </Box>
          )}
          {headerName && <di className="service-header-name">{headerName}</di>}

          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "flex", md: "none" },
              justifyContent: "flex-end",
            }}
          >
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              className="mobile-menu-wrapper"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: "block", md: "none" } }}
            >
              {pages.map((page) => (
                <MenuItem
                  className="mobile-menu-item-wrapper"
                  key={page}
                  onClick={() => {
                    handleScrollToPortion(page);
                    handleCloseNavMenu();
                  }}
                >
                  <a className="mobile-menu-item" sx={{ textAlign: "center" }}>
                    {page}
                  </a>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Box
            className="header-menu-wrapper"
            sx={{
              flexGrow: 1,
              display: { xs: "none !important", md: "flex !important" },
            }}
          >
            {pages.map((page) => (
              <Box key={page} className={page === "Services" ? "dropdown" : ""}>
                <Button
                  disableRipple
                  onClick={() => {
                    page !== "Services" && handleScrollToPortion(page);
                    handleCloseNavMenu();
                  }}
                  className={page === "Services" ? "dropbtn" : ""}
                  sx={{ my: 2, color: "white", display: "block" }}
                >
                  {page}
                </Button>

                {page === "Services" && (
                  <div className="dropdown-content">
                    {ourServicesContent.ourServices?.map((service) => (
                      <a href={`/services/${service.name}`} key={service.name}>
                        {service.name}
                      </a>
                    ))}
                  </div>
                )}
              </Box>
            ))}
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Box sx={{ flexGrow: 0, display: { xs: "none", md: "flex" } }}>
              <button
                className="contact-us-btn"
                onClick={() => {
                  handleScrollToPortion("Contact");
                }}
              >
                Contact Us
              </button>
            </Box>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography sx={{ textAlign: "center" }}>
                    {setting}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default HeaderComponent;
